/** The public landing page and customer app share one CloudFront distribution. */
export function entrySurfaceForHostname(hostname: string): 'marketing' | 'customer' {
  return hostname.trim().toLowerCase() === 'app.route42.ai' ? 'customer' : 'marketing';
}
